import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import produce from 'immer';
import logger from '../common/logger';
import { tutorialSliceInitialState, tutorialSliceName } from '../common/constants';
import { getDataState } from './universalDataFetchers';
import XHRError from '../common/xhrError';

export const fetchTutorialData = createAsyncThunk(
  'tutorialData',
  ({
    match, env, useMocks, lmsHeaders, isPreview,
  }, { rejectWithValue }) => {
    const { params } = match;
    return getDataState({
      params, env, useMocks, lmsHeaders, isPreview,
    }).then((res) => {
      if (!res?.stillOffered) {
        throw new XHRError(404, 'No active tutorial found.');
      }
      return res;
    }).catch((err) => rejectWithValue(err));
  },
);

export const tutorialSlice = createSlice({
  name: tutorialSliceName,
  initialState: tutorialSliceInitialState,
  reducers: {
    setTutorialData: (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState.data = action.payload;
      });
      return newState;
    },
    setIsTutorialCompleted: (state, action) => {
      const newState = produce(state, (draftState) => {
        draftState.isTutorialCompleted = action.payload;
      });
      return newState;
    },
    clearLoader: (state) => {
      const newState = produce(state, (draftState) => {
        draftState.isLoaderVisible = false;
      });

      return newState;
    },
    // setTutorialRelatedTutorialListOrder: (state, action) => {
    //   const newState = produce(state, (draftState) => {
    //     draftState.data.relatedLearning.tutorials = action.payload.data;
    //   });
    //   return newState;
    // },
    // setTutorialRelatedCuratedListOrder: (state, action) => {
    //   const newState = produce(state, (draftState) => {
    //     draftState.data.relatedLearning.curateds = action.payload.data;
    //   });
    //   return newState;
    // },
  },
  extraReducers: {

    [fetchTutorialData.pending]: (state) => ({
      ...state,
      isLoaderVisible: true,
    }),
    [fetchTutorialData.fulfilled]: (state, action) => {
      const data = action?.payload || {};
      if (!data.error) {
        const newState = produce(state, (draftState) => {
          draftState.data = data;
          draftState.isLoaderVisible = false;
        });

        return newState;
      }

      return state;
    },
    [fetchTutorialData.rejected]: (state, action) => {
      logger.error('Error in fetchTutorialData: ', action.payload);
      return {
        ...state,

      };
    },
  },
});
export const {
  setTutorialData, setIsTutorialCompleted, clearLoader,
  // setTutorialRelatedTutorialListOrder, setTutorialRelatedCuratedListOrder,
} = tutorialSlice.actions;

export const getTutorialData = (state) => state.tutorialData.data;
export const isTutorialCompleted = (state) => state.tutorialData.isTutorialCompleted;
export const isLoaderVisible = (state) => state.tutorialData.isLoaderVisible;
export const getLearningMode = (state) => state.tutorialData.data.learningMode;

export default tutorialSlice.reducer;
